<template>
  <div class="card-container">
    <ReviewsCategoriesCard
      class="summary-card"
      :is-loading="!total.basic"
      :title="$t('message.reviews.categories.averageRate')"
    >
      <template v-if="total.basic">
        <div class="summary-card__row">
          <span class="summary-card__label"
            >{{ $t("message.reviews.categories.selectedRange") }}:</span
          ><span class="summary-card__value">{{
            averageRatings.basic.value
          }}</span>
          <IncreaseIndicator
            v-if="differenceInAverageRate !== 0"
            class="summary-card__indicator"
            float-value
            :show-unit="false"
            :value="differenceInAverageRate"
          />
        </div>
        <div v-if="total.comparison" class="summary-card__row">
          <span class="summary-card__label"
            >{{ $t("message.reviews.categories.inGivenPeriod") }}:</span
          ><span class="summary-card__value summary-card__value--small">{{
            averageRatings.comparison.value
          }}</span>
        </div>
        <div class="summary-card__row">
          <span class="summary-card__label"
            >{{ $t("message.reviews.categories.fromBegin") }}:</span
          ><span class="summary-card__value summary-card__value--small">{{
            total.basic.average
          }}</span>
        </div>
      </template>
    </ReviewsCategoriesCard>
    <ReviewsCategoriesCard
      class="summary-card"
      :is-loading="!total.basic"
      :title="$t('message.reviews.categories.reviewsCount')"
    >
      <div class="summary-card__row" v-if="total.basic">
        <span class="summary-card__label"
          >{{ $t("message.reviews.categories.selectedRange") }}:</span
        ><span class="summary-card__value">{{
          total.basic.count | formatNumber
        }}</span>
        <IncreaseIndicator
          v-if="differenceInComparisonCount !== 0"
          class="summary-card__indicator"
          :value="differenceInComparisonCount"
        />
      </div>
      <div class="summary-card__row" v-if="total.comparison">
        <span class="summary-card__label"
          >{{ $t("message.reviews.categories.inGivenPeriod") }}:</span
        ><span class="summary-card__value summary-card__value--small">{{
          total.comparison.count | formatNumber
        }}</span>
      </div>
      <div v-if="processingQuantity" class="summary-card__row">
        <span class="summary-card__label"
          >{{ $t("message.sentiment.reviewsProcessing") }}:</span
        ><span class="summary-card__value summary-card__value--small mr-1">{{
          processingQuantity
        }}</span>

        <ReviewsCategoriesProcessingTooltip
          :label="$t('message.sentiment.reviewsProcessingNumber')"
        />
      </div>
    </ReviewsCategoriesCard>
  </div>
</template>

<script>
import ReviewsCategoriesCard from "@/components/Reviews/Categories/ReviewsCategoriesCard.vue";
import IncreaseIndicator from "@/components/Dashboard/base/IncreaseIndicator";
import ReviewsCategoriesProcessingTooltip from "@/components/Reviews/Categories/ReviewsCategoriesProcessingTooltip.vue";

export default {
  name: "ReviewsCategoriesSummary",
  components: {
    ReviewsCategoriesCard,
    IncreaseIndicator,
    ReviewsCategoriesProcessingTooltip
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    processingQuantity: {
      type: Number
    }
  },
  computed: {
    total() {
      return this.data.total;
    },
    averageRatings() {
      return this.data.averageRatings;
    },
    differenceInAverageRate() {
      return this.averageRatings.comparison
        ? this.averageRatings.basic.value - this.averageRatings.comparison.value
        : this.averageRatings.basic.value - this.total.basic.average;
    },
    differenceInComparisonCount() {
      return this.total.comparison
        ? -(100 - (this.total.basic.count / this.total.comparison.count) * 100)
        : 0;
    }
  }
};
</script>

<style lang="scss" scoped>
$increase-indicator-color: #237772;
$decrease-indicator-color: #d4295c;
.card-container {
  display: flex;
  width: 100%;

  & > * {
    width: 100%;

    & + * {
      margin-left: $spacing * 5;
    }
  }
}

.summary-card {
  ::v-deep &__row {
    display: flex;
  }

  &__row {
    display: flex;
    align-items: center;

    & + & {
      margin-top: $spacing * 2 !important;
    }
  }

  &__value {
    @include font-size(40px);
    font-weight: 700;
    margin-left: $spacing;

    &--small {
      @include font-size(20px);
    }
  }

  &__indicator {
    margin-left: $spacing * 1.5;
  }

  ::v-deep .v-card {
    min-height: 225px;
    padding-bottom: $spacing * 2 !important;
  }

  ::v-deep .v-card__text {
    justify-content: flex-start !important;
  }
}

::v-deep .card__indicator {
  &.increasing {
    * {
      color: $increase-indicator-color !important;
    }
  }
  &.decreasing {
    * {
      color: $decrease-indicator-color !important;
    }
  }
}
</style>
